import { faEye, faIdBadge, faLightbulb } from "@fortawesome/free-regular-svg-icons";
import { faAward, faBolt, faBookOpenReader, faBrain, faCertificate, faMagic, faMagicWandSparkles, faProjectDiagram, faRobot, faShieldAlt, faUserCircle, faUsers } from "@fortawesome/free-solid-svg-icons";

export const slideData = [
    { id: 1, caption: "first caption" },
    { id: 2, caption: "Second caption" },
    { id: 3, caption: "Third caption" },
    { id: 4, caption: "Fourth caption" },
    { id: 5, caption: "Fifth caption" }
]

export const techStacks = [
    "React & Next.js",
    "Node.js & Express",
    "PHP & Laravel",
    "AI/ML Integration",
    "Cloud Deployment",
    "Progressive Web Apps"
];

export const compliance = [
    "ISO 27001",
    "SOC 2 Type II",
    "GDPR Compliant",
    "HIPAA Ready",
    "PCI DSS",
    "NIST Framework",
    "FedRAMP",
    "CCPA Compliant"
]

export const graphTools = [
    "Adobe Creative Suite",
    "Figma & Sketch",
    "Midjourney AI",
    "Canva Pro",
    "Pixellab",
    "Procreate"
]

export const mobileStacks = [
    "React Native",
    "Flutter",
    "Swift/Kotlin",
    "Core ML",
    "Firebase ML",
    "IOT-Integration"
]

export const secFramework = [
    {
        caption: "AI Assessment",
        descr: "Intelligent security posture analysis and risk evaluation"
    },
    {
        caption: "Smart Implementation",
        descr: "AI-guided security solution deployment and configuration"
    },
    {
        caption: "Continuous Learning",
        descr: "Machine learning models that adapt to new threats"
    },
    {
        caption: "Predictive Response",
        descr: "Proactive threat hunting and incident prevention"
    }
];

export const processes = [
    {
        caption: "AI Analysis",
        descr: "Intelligent requirement analysis and project planning"
    },
    {
        caption: "Smart Design",
        descr: "AI-assisted UI/UX design optimization"
    },
    {
        caption: "Intelligent Development",
        descr: "Code generation and optimization with AI tools"
    },
    {
        caption: "AI Testing",
        descr: "AI-assisted UI/UX design optimization"
    }
];

export const mobiProcesses = [
    {
        icon: faBrain,
        caption: "AI Integration",
        descr: "Machine learning models embedded directly in your mobile app"
    },
    {
        icon: faBolt,
        caption: "Real-time Processing",
        descr: "Lightning-fast AI computations with edge computing capabilities"
    },
    {
        icon: faUserCircle,
        caption: "Personalization",
        descr: "AI-driven user experience that adapts to individual preferences"
    },

];

export const secProcesses = [
    {
        icon: faBrain,
        caption: "Machine Learning Defence",
        descr: "Self-learning security systems that adapt to new threats automatically"
    },
    {
        icon: faBolt,
        caption: "Real-time Response",
        descr: "Instant AI-driven incident response and threat mitigation"
    },
    {
        icon: faEye,
        caption: "Behavioural Analysis",
        descr: "AI-powered user behavior analysis to detect insider threats"
    },

];

export const homeProcesses = [
    {
        icon: faBolt,
        caption: "Lightening Fast",
        descr: "AI accelerates development and deployment times by 10x"
    },
    {
        icon: faRobot,
        caption: "Intelligent Automation",
        descr: "Smart systems that learn and adapt to your business needs"
    },
    {
        icon: faShieldAlt,
        caption: "Enhanced Security",
        descr: "AI-powered threat detection and prevention systems"
    },

]

export const graphicsProcesses = [
    {
        icon: faMagicWandSparkles,
        caption: "AI Style Transfer",
        descr: "Transform designs with intelligent style adaptation and artistic filters"
    },
    {
        icon: faEye,
        caption: "Visual Recognition",
        descr: "AI-powered image analysis for optimal composition and color harmony"
    },
    {
        icon: faMagic,
        caption: "Generative Design",
        descr: "Create infinite design variations using machine learning algorithms"
    },
];

export const personnel = [
    {
        icon: faUsers,
        caption: "10+",
        descr: "Team Members"
    },
    {
        icon: faProjectDiagram,
        caption: "20+",
        descr: "Projects"
    },
    {
        icon: faBrain,
        caption: "8+",
        descr: "Specialists"
    },
    {
        icon: faBolt,
        caption: "24/7",
        descr: "Support"
    }
]

export const values = [
    {
        icon: faLightbulb,
        caption: "Innovation First",
        descr: "We embrace cutting-edge AI technologies and push the boundaries of what's possible in tech."
    },
    {
        icon: faAward,
        caption: "Collaborative excellence",
        descr: "Our diverse team works together to create solutions that exceed client expectations."
    },
    {
        icon: faBookOpenReader,
        caption: "Continuous learning",
        descr: "We invest in our team's growth and stay ahead of rapidly evolving AI technologies."
    }
]

export const grProcesses = [
    {
        caption: "AI Descovery",
        descr: "Intelligent analysis of your brand and creative requirements"
    },
    {
        caption: "Concept Generation",
        descr: "AI-assisted ideation and creative concept development"
    },
    {
        caption: "Smart Design",
        descr: "AI-enhanced design creation with real-time optimization"
    },
    {
        caption: "Intelligent Refinement",
        descr: "AI-powered feedback analysis and design perfection"
    }
]